import React from "react";
import "../../components/Expense/ExpList.css";
import SearchIcon from "@mui/icons-material/Search";
import Search from "../../../src/images/Search.png";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const Petcratelists = ({
  userDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  openAddProfile,
  setOpenAddProfile,
}) => {
  function HandleChange(param) {
    GetId(param);
  }

  function getStatusColor(status) {
    switch (status) {
      case "ACTIVE":
        return "#28A745";
      case "INACTIVE":
        return "#DC3545";
      default:
        return "blue";
    }
  }

  return (
    <div className="container-fluid">
      <div className="departmentList">
        <table>
          <tr className="departmentListHeading">
            <th>S No.</th>
            <th>Product Name</th>
            <th>Price</th>

            <th>Length</th>
            <th>Width</th>
            <th>Height</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
          <tr>
            <td>1</td>
            <td>IATA Approved Crate 48 Inches</td>
            <td>₹ 30,343</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Petcratelists;
